// pages/Dashboard.jsx
import SubscriptionDetails from "../../components/home/subscriptionComponents/SubscriptionDetails";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <SubscriptionDetails />
    </HomeLayout>
  );
}
